import { BeehiveOutlineIcon } from './BeehiveOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 667E2F2C-B896-48EF-B5F9-EF9436A8BE4B
 * name beehive-outline
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/beehive-outline.svg
 * tags
 * - Nature 
 * - Agriculture 
 */
export const HoneyOutlineIcon = BeehiveOutlineIcon;
export default HoneyOutlineIcon